import React from 'react'
import ApiUrl from '../../../../configTools/apiUrl'
import { Link } from 'react-router-dom'

const Top = ({openChatBox}) => {
  return (
    <div className='open_chatbox_top'>
        <div className='open_chatbox_top_in'>
            <div 
                className='open_chatbox_top_image' 
                style={{
                    backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+openChatBox.userimage})`
                }}
            >
            </div>
            <div className='open_chatbox_top_name'>
                <Link to={'/user/'+openChatBox.username}>
                    <h4>{openChatBox.first} {openChatBox.last}</h4>
                    <h5>{openChatBox.username}</h5>
                </Link>
            </div>
        </div>
    </div>
  )
}

export default Top
